import { Columns } from './Columns';
import { Hero } from './Hero';
import { Quote } from './Quote';
import { LatestPosts } from './LatestPosts';
import { Logos } from './Logos';
import { Video } from './Video';

export { Columns, Hero, Quote, LatestPosts, Logos, Video };
